import useLanguage from '~/client/hooks/useLanguage';
import useSite from '~/client/hooks/useSite';
import getBlogSectionsString from '~/shared/blog/helpers/getBlogSectionsString';
import { useBlogArticlesQuery } from '../../../graphql/BlogArticlesQuery.generated';

type Args = { section?: string };

const useRecentArticles = ({ section }: Args) => {
  const { site, siteConfig } = useSite();
  const { code: language } = useLanguage();
  const { data, loading } = useBlogArticlesQuery({
    variables: {
      first: 4,
      filter: {
        site,
        language,
        section: section ?? getBlogSectionsString(siteConfig),
      },
    },
  });
  const recentArticles = data?.content?.pages?.edges;

  return { articles: recentArticles, loading };
};

export default useRecentArticles;
